import React from 'react';
import { Info } from 'lucide-react';
import { useLang } from '../i18n';

export default function CoverageBanner({ coverage }) {
  const { t } = useLang();
  if (!coverage || coverage.covered) return null;
  return (
    <div data-testid="coverage-banner" className="rounded-xl border border-amber/40 bg-amber/10 p-4 flex gap-3">
      <Info className="w-5 h-5 text-amber shrink-0 mt-0.5" />
      <div>
        <div className="text-sm font-semibold text-amber">{t('tpl_only_title')}</div>
        <div className="text-xs text-slate-300 mt-1 leading-relaxed">{t('tpl_only_body')}</div>
      </div>
    </div>
  );
}
